import React from 'react'
import './DriverHome.css';
import { useEffect, useReducer, useState, useRef } from 'react';
import fetchData from '../../function/fetchData'
import DriversPage from './DriversPage';
import BarLoader from "react-spinners/MoonLoader";



const override: CSSProperties = {
    margin: "100px auto",
    display: "block",
    borderColor: "red",
};

const reducer = (state, action) => {
    if(action.type === "SAVE_TOKEN"){
        return {
            ...state,
            tokenOfDriver: action.payload,
            loading: false
        }
    }
    else if(action.type === "LOADING"){
        return {
            ...state,
            loading: true
        }
    }
    else if(action.type === "STOP_LOADING"){
        return {
            ...state,
    
        }
    }
    else if(action.type === "SAVE_DATA_FROM_SERVER"){
        return {
            ...state,
            ...action.payload,
            extraTrip: action.payload2,
            listOfBreak: action.payload3
        }
    }
    else if(action.type === "SAVE_GPS"){
        return {
            ...state,
  
            gpsCord: true,
        }
    }
    else if(action.type === "SAVE_STATUS_OF_DRIVER"){
        return {
            ...state,
 
            status: action.payload,
        }
    }
    else if(action.type === "ACTUAL_ORDERS"){
        return {
            ...state,
            orders: action.payload,
            extraTrip: action.payload2
        }
    }
    else if(action.type === "STATUS_OF_DRIVER"){
        return {
            ...state,
            status: action.payload,
        }
    }
 }

 const server = process.env.REACT_APP_SERVER_ADRES;


const defaultState = {
    server: server,
    tokenOfDriver : null,
    status: 0,
    activeOrders: 0,
    orders: [],
    listOfBreak: [],
    extraTrip: [],
    driverInfo: {},
    gpsCord: false,
    loading: false,
}

// ********* MAIN APP *********
const DriverHome = () => {
    const [state, dispatch] = useReducer(reducer, defaultState )
  
    const [error, setError] = useState(null);
    const [driverGps, setDriverGps] = useState()
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const doWeHaveToken = useRef(false)
   

 
    // Má data v localstorage?
    useEffect( () => {
        const data = localStorage.getItem('driverToken');
        if(data) {
            dispatch({type: "SAVE_TOKEN", payload:  data})
            doWeHaveToken.current = true
        }
    }, [])


   
    const onHandle = () => {
        // Pošle přihlašovací data na serve a čeká na TOKEN
        dispatch({type: "LOADING"})
        const adresOfServer = state.server + "/api2/forDriver.php";

        const whatToSend = {
            action: "GET_TOKEN",
            email : email,
            password: password,
        }
        fetchData(adresOfServer, whatToSend)
        .then((res) => {
            if(res.info === "OK"){
                // Nastaví token
                dispatch({type: "SAVE_TOKEN", payload:  res.driverToken})
                // Uloží token
                localStorage.setItem('driverToken', res.driverToken);
                
   

            } else if(res.info === "wrong acces"){
                alert("Zadali jste špatné jméno, nebo heslo")
            }
        })
    }  

 // Získá data pro řidiče
    const adresOfServer = state.server + "/api2/forDriver.php";

    const whatToSend = {
        action: "ALL_TO_DRIVER", 
        tokenOfDriver : state.tokenOfDriver,
    }

    useEffect( () => {
        if(state.tokenOfDriver){
            // Spustí první fetch
            fetchData(adresOfServer, whatToSend)
            .then((res) => {
                const arrayToSave = {driverInfo: res.driverInfo, orders: res.orders, status: res.driverInfo.status, activeOrders: res.activeOrders}
                dispatch({type: "SAVE_DATA_FROM_SERVER" , payload : arrayToSave , payload2: res.extraTrip, payload3: res.listOfBreaks})
                })

        }
        
    },[state.tokenOfDriver, state.status])

    // Nastaví pravidelný čas, kdy data obnoví
    useEffect(() => {
        const intervalId = setInterval(() => {
            if (doWeHaveToken.current) {
                fetchData(adresOfServer, whatToSend)
                    .then((res) => {
                        dispatch({ type: "ACTUAL_ORDERS", payload: res.orders , payload2: res.extraTrip , payload3: res.listOfBreaks});
                    });
            }
        }, 30000);
    
        return () => clearInterval(intervalId);
    
    }, [doWeHaveToken, fetchData, adresOfServer, whatToSend, dispatch]);


   //GEOLOCAT
  useEffect(() => {
  
    // Požádá o GPS polohu
      if (!navigator.geolocation) {
          setError('Geolocation není podporována vaším prohlížečem.');
          return;
      }
      navigator.geolocation.watchPosition(
          (position) => {
            
            if(position) {
                setDriverGps({lat: position.coords.latitude, lng: position.coords.longitude})
            } 

          },
          (error) => {
              setError(error.message);
          },
          
      );
  }, []);
    


     // Pošle pravidelně GPS
     useEffect( () => {
        if(state.tokenOfDriver){

            const adresOfServer = state.server + "/api2/forDriver.php";

            const whatToSend = {
                action: "SAVE_GPS", 
                tokenOfDriver : state.tokenOfDriver,
                gps: driverGps,
                
            }
      
            fetchData(adresOfServer, whatToSend)
            .then((res) => {
                if(res.info === 'GPSsaved'){
                    dispatch({type: "SAVE_GPS"})
                } 
            })
        }
    },[driverGps])



    


    if(!state.tokenOfDriver){
        return (
            <div className='driverHomeContainer'>
                <div className="driverHomeContant">
                    <label>Přihlaště se</label>
                    <input type="text" placeholder='Email' className='password' value={email} onChange={(e)=>setEmail(e.target.value)}/>
                    <input type="text" placeholder='Vaše heslo' className='password' value={password} onChange={(e)=>setPassword(e.target.value)}/>
                    <button className='button' onClick={onHandle}>Přihlásit se</button>
                  </div>
            </div>
          )
    } else {
        return ( 
            <DriversPage state={state} dispatch={dispatch}/>
        )
    } 

}

export default DriverHome
